import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
// Components
import { withRouter } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

class ModalAlertSetWalletPin extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { isLoggedIn, profileData, jwt_token } = this.props;

    if (isLoggedIn) {
      if (prevProps.isLoggedIn !== isLoggedIn) {
        if (isLoggedIn && jwt_token !== null) {
          if (profileData.wallet_flag === 0) {
            this.props.showModalAlertWalletPin();
          }
        }
      }
    }
  }

  _goToSetWalletPin = () => {
    this.props.hideAlertSetWalletPin();
    this.props.history.push("/my-profile/?tabs=wallet-settings");
  };

  render() {
    const { visibleAlertSetWalletPin } = this.props;

    return (
      <Modal
        show={visibleAlertSetWalletPin}
        onHide={() => {}}
        aria-labelledby="example-modal-sizes-title-lg"
        centered={true}
        backdrop="static"
        className="modal-alert-set-wallet-pin"
      >
        <Modal.Header>
          <Modal.Title>Wallet Pin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You have not set your payment password yet. For security purpose,
            please set your payment password now.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <p
            className="mr-3 text-primary set-btn"
            onClick={this._goToSetWalletPin}
          >
            SET NOW
          </p>
          <p
            className="text-primary set-btn"
            onClick={this.props.hideAlertSetWalletPin}
          >
            SET LATER
          </p>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalAlertSetWalletPin.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  visibleAlertSetWalletPin: PropTypes.bool.isRequired,
  profileData: PropTypes.object.isRequired,
  jwt_token: PropTypes.any.isRequired
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.Auth.isLoggedIn,
    visibleAlertSetWalletPin: state.App.visibleAlertSetWalletPin,
    profileData: state.Auth.profileData,
    jwt_token: PropTypes.any
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showModalAlertWalletPin: () =>
      dispatch(actions.showModalAlertSetWalletPin()),

    hideAlertSetWalletPin: () => {
      dispatch(actions.hideModalAlertSetWalletPin());
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ModalAlertSetWalletPin)
);
